import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/de'
import 'dayjs/locale/de-at'
import 'dayjs/locale/de-ch'
import 'dayjs/locale/en'
import 'dayjs/locale/en-au'
import 'dayjs/locale/en-gb'
// import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/fi'
import 'dayjs/locale/fr'
import 'dayjs/locale/fr-ch'
import 'dayjs/locale/nl'
import 'dayjs/locale/nl-be'
import 'dayjs/locale/sv'
import 'dayjs/locale/sv-fi'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import toObject from 'dayjs/plugin/toObject'

dayjs.extend(toObject)
dayjs.extend(localizedFormat)
// dayjs.extend(customParseFormat);

export const DEFAULT_PAYMENT_TERMS: number = 14

export const isDateStringValid = (dateStr: string): boolean => {
  // Date should be in format 2019-01-08T10:27:29.000Z
  return Boolean(dateStr) && Boolean(dateStr.match(/^[0-9]{4}-[0-9]{1,2}/g))
}

export const updateHMS = (dateStr: string): string => {
  const { years, months, date } = dayjs(dateStr).toObject()
  const dateNew = dayjs().year(years).month(months).date(date)
  return dateNew.toISOString()
}

export const calculateDaysFromStartDate = (startDate: Dayjs, days: number = DEFAULT_PAYMENT_TERMS): Dayjs => {
  if (isNaN(days)) {
    days = DEFAULT_PAYMENT_TERMS
  }
  return startDate.add(days, 'days')
}

export function formatDateByLocale(date: string, locale: string): string {
  const dayjsDate = ['fi_FI', 'en_GB', 'de_DE', 'en_EN', 'fr_FR', 'nl_NL', 'sv_SV'].includes(locale)
    ? dayjs(date).locale(locale.toLowerCase().substring(3))
    : dayjs(date).locale(locale.toLowerCase().replace('_', '-'))
  return dayjsDate.format('L')
}

export const formatDate = (date: string | number | dayjs.Dayjs | Date, format: string, language?: string): string => {
  // eslint-disable-next-line no-nested-ternary
  const dayjsFormat = format ? (!format.includes('YYYY') ? format.replace('Y', 'YYYY') : format) : ''
  const dayjsDate = dayjs(date)
  if (language) {
    return dayjsDate.locale(language).format(dayjsFormat)
  }
  return dayjsDate.format(dayjsFormat)
}

/**
 * Converts legacy date formats (d.m.Y,d/m/Y,Y-n-e,d M Y) for DatePicker
 * @param {string} format
 * @returns {string}
 */
export function transformDateFormatForMoment(format: string = 'd/m/Y'): string {
  switch (format) {
    case 'd.m.Y':
      return 'D.M.Y'
    case 'd/m/Y':
      return 'DD/MM/Y'
    case 'd-m-Y':
      return 'DD-MM-Y'
    case 'Y-n-e':
      return 'Y-MM-DD'
    case 'd M Y':
      return 'D MMM Y'
    case 'h:i':
      return 'H:mm'
    case 'h.i':
      return 'H.mm'
    case 'H:i p':
      return 'h:mm a'
    case 'p H:i':
      return 'a h:mm'
    default:
      return format // so that this works if/when the format is fixed one day
  }
}

export function transformDateTimeFormat(dateFormat: string, timeFormat: string): string {
  return `${transformDateFormatForMoment(dateFormat)} ${transformDateFormatForMoment(timeFormat)}`
}

export const DatetoSQL = (date: Date, noTime: boolean = false) => {
  const mon = date.getMonth() + 1
  const day = date.getDate()

  const monStr = mon < 10 ? '0' + mon : String(mon)
  const dayStr = day < 10 ? '0' + day : String(day)

  const start = date.getFullYear() + '-' + monStr + '-' + dayStr

  if (noTime === true) {
    return start
  }

  const o = {
    hours: date.getHours(),
    minutes: date.getMinutes(),
    secs: date.getSeconds(),
  }

  for (const i in o) {
    if (o[i] < 10) {
      o[i] = '0' + o[i]
    }
  }

  return start + ' ' + o.hours + ':' + o.minutes + ':' + o.secs
}
